module.exports = __webpack_public_path__ + "static/img/pay-huabei11.12b5a1fe.png";